var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHairDryer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M25.437 34.792s-1.772-3.865-1.709-6.74M30.03 11.736c-5.153-3.669-9.779-1.76-11.453-.827l-7.685-.27c-.68-.04-1.255.34-1.283.844l-.108 1.944c-.03.505.5.946 1.18.985l7.641.985c2.36 1.928 6.483 2.68 6.483 2.68 2.344-.213 4.731-1.185 4.731-1.185 1.38-1.338 1.024-4.78.494-5.156Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20.03 16.486c.482.287 1.376 1.036 1.554 2.72l.492 8.394s1.323.87 3.286.152l-.159-9.671M11.771 10.67l-.205 3.856"
}))));
export default SvgHairDryer;